export const shared = { email: "support@somnilog.care" };
